import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError} from 'rxjs/operators';
import { Page } from '../../models/page';
import { plainToClass } from 'class-transformer';

@Injectable()
export class PagesProvider {

  pages: Array<Page> = []
  page: Page = null
  resource: Page = null

  constructor(private _http: HttpClient,
              private storage: Storage) {
    // need toPromise().then() to force load
    // this.getPages().toPromise().then()
  }

  getResource(slug: String): Observable<any> {
    const observable = new Observable<Page>( observer => {
      this._http.get('/pages/' + slug, {observe: 'response'})
                .pipe(catchError(this.handleError))
                .subscribe(r => {
                  this.resource = r.body['data'] as Page
                  observer.next(this.resource)
                })
    })
    return observable;
  }

  getPage(slug: String): Observable<any> {
    const observable = new Observable<Page>( observer => {
      this._http.get('/pages/' + slug, {observe: 'response'})
                .pipe(catchError(this.handleError))
                .subscribe(r => {
                  this.page = r.body['data'] as Page
                  observer.next(this.page)
                })
    })
    return observable;
  }

  getPages(): Observable<any> {
    const observable = new Observable<Array<Page>>( observer => {

      this.loadPages().then((value: any) => {
        if (value) {
          this.copyPagesFrom(value)
          observer.next(this.pages)
        }

        const token = localStorage.getItem('token');
        if (token != null && token.length > 0) {
          this._http.get('/pages', {observe: 'response'})
                    .pipe(catchError(this.handleError))
                    .subscribe(r => {
                      if (r.body['status'] === 204) {
                        // Success but the api returned an empty body since its lastSync matches the lastSync we sent. DON'T
                        // call observer.next(this.resources) since that causes the page to needlessly update.
                        return
                      }

                      this.copyPagesFrom(r.body['data'])
                      this.storePages()

                      observer.next(this.pages)
                    });
        } else {
          observer.next(this.pages)
        }
      })
    })
    return observable;
  }

public setPagesFromLogin(data: Object) {
    this.copyPagesFrom(data)
    this.storePages()
  }

  loadPages(): Promise<any> {
    return this.storage.get('pages.v1')
  }

  storePages(): Promise<any> {
    return this.storage.set('pages.v1', this.pages)
  }

  private copyPagesFrom(data: Object) {
    const pages: Array<Page> = plainToClass(Page, data || []) as any
    this.pages = pages
  }



  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
        // A client-side or network error occurred. Handle it accordingly.
        console.error('An error occurred:', error.error.message);
    } else {
        // The backend returned an unsuccessful response code.
        // The response body may contain clues as to what went wrong,
        console.error(
            `Backend returned code ${error.status}, ` +
            `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError('Something bad happened retrieving pages; please try again later.');
  }

}
